var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "page_title" }, [_c("custom-breadcrumb")], 1),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-header" },
      [
        _c(
          "div",
          { staticClass: "search-box" },
          [
            _c(
              "el-select",
              {
                attrs: { clearable: "", placeholder: "Order status" },
                on: { change: _vm.search },
                model: {
                  value: _vm.query.order_status,
                  callback: function($$v) {
                    _vm.$set(_vm.query, "order_status", $$v)
                  },
                  expression: "query.order_status"
                }
              },
              _vm._l(_vm.orderStatusOptions, function(item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value }
                })
              }),
              1
            ),
            _vm._v(" "),
            _c("el-input", {
              staticClass: "search_input",
              attrs: {
                "prefix-icon": "el-icon-search",
                placeholder: "Order# / Product Name / tracking# / SKU",
                clearable: ""
              },
              model: {
                value: _vm.query.keywords,
                callback: function($$v) {
                  _vm.$set(_vm.query, "keywords", $$v)
                },
                expression: "query.keywords"
              }
            }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "search-btn",
                attrs: { type: "primary" },
                on: { click: _vm.search }
              },
              [_vm._v("Search\n      ")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticClass: "search-btn",
            on: {
              click: function($event) {
                return _vm.toCreateOrder()
              }
            }
          },
          [_vm._v("\n      Create Order\n    ")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "loading",
            rawName: "v-loading",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "refer-content"
      },
      [
        _vm.dataList.length > 0
          ? _vm._l(_vm.dataList, function(batch, batchIndex) {
              return _c(
                "el-card",
                {
                  key: batchIndex,
                  staticClass: "order",
                  attrs: { shadow: "never" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "order-header",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c("div", { staticClass: "header-left" }, [
                        _c("div", { staticClass: "header-item" }, [
                          _c("div", { staticClass: "header-item-title" }, [
                            _vm._v("BatchOrder No.")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "header-item-con" }, [
                            _vm._v(_vm._s(batch.batchNo))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "header-item" }, [
                          _c("div", { staticClass: "header-item-title" }, [
                            _vm._v("Order Placed")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "header-item-con" }, [
                            _vm._v(_vm._s(batch.time))
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "header-item" }, [
                          _c("div", { staticClass: "header-item-title" }, [
                            _vm._v("Total")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "header-item-con black-weight" },
                            [_vm._v(_vm._s(batch.payAmount))]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "header-item" }, [
                          _c("div", { staticClass: "header-item-title" }, [
                            _vm._v("Status")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "header-item-con black-weight" },
                            [_vm._v(_vm._s(batch.batchStatus))]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "text-btn",
                          attrs: { type: "text" },
                          on: {
                            click: function($event) {
                              return _vm.handleDetail(batch.batchNo)
                            }
                          }
                        },
                        [_vm._v("View Details")]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(batch.orderInfoList, function(order, orderIndex) {
                    return _c(
                      "div",
                      { key: orderIndex, staticClass: "order-content" },
                      [
                        _c("div", { staticClass: "con-title-1" }, [
                          _c("span", { staticClass: "title-item" }, [
                            _vm._v("Order# " + _vm._s(order.orderId))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "title-item" }, [
                            _vm._v("\n                Total\n              "),
                            _c(
                              "span",
                              { staticStyle: { "padding-left": "10px" } },
                              [
                                _vm._v(
                                  "$" +
                                    _vm._s(order.payAmount) +
                                    "\n            "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "title-item" }, [
                            _vm._v("\n                Status\n              "),
                            _c(
                              "span",
                              { staticStyle: { "padding-left": "10px" } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$tool.valueToLabel(
                                        order.orderStatus,
                                        _vm.orderStatusOptions
                                      )
                                    )
                                )
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "con-title-2 black-weight" }, [
                          _vm._v(_vm._s(order.brandName))
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "con-images" },
                          [
                            _vm._l(order.orderDetails, function(
                              detail,
                              imageIndex
                            ) {
                              return _c(
                                "div",
                                { key: imageIndex },
                                [
                                  imageIndex < 5
                                    ? _c("el-image", {
                                        staticClass: "img-item",
                                        attrs: {
                                          src: detail.skuImg,
                                          fit: "fill"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  order.showAll && imageIndex >= 5
                                    ? _c("el-image", {
                                        staticClass: "img-item",
                                        attrs: {
                                          src: detail.skuImg,
                                          fit: "fill"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            order.orderDetails.length > 5 && !order.showAll
                              ? _c(
                                  "div",
                                  { staticClass: "more-btn" },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          "+" + (order.orderDetails.length - 5)
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("el-button", {
                                      staticStyle: {
                                        color: "#3E3E3E",
                                        "font-size": "20px"
                                      },
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-arrow-right"
                                      },
                                      on: {
                                        click: function($event) {
                                          order.showAll = true
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            order.showAll
                              ? _c("el-button", {
                                  staticClass: "more-btn",
                                  staticStyle: {
                                    color: "#3E3E3E",
                                    "font-size": "20px"
                                  },
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-arrow-left"
                                  },
                                  on: {
                                    click: function($event) {
                                      order.showAll = false
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { "margin-top": "-34px" } },
                          [
                            _c("span", { staticClass: "black-weight" }, [
                              _vm._v("Memo:")
                            ]),
                            _vm._v(" "),
                            order.memo && order.readMore
                              ? _c("span", [_vm._v(_vm._s(order.memo))])
                              : _vm._e(),
                            _vm._v(" "),
                            order.memo && order.memo.length > 80
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(order.memo.substring(0, 80) + "...")
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            order.memo &&
                            order.memo.length > 80 &&
                            !order.readMore
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "text-btn",
                                    staticStyle: {
                                      color: "#3E3E3E",
                                      "margin-left": "20px",
                                      height: "20px"
                                    },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        order.readMore = !order.readMore
                                      }
                                    }
                                  },
                                  [_vm._v(" Read More\n            ")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            order.readMore
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "text-btn",
                                    staticStyle: {
                                      color: "#3E3E3E",
                                      "margin-left": "20px",
                                      height: "20px"
                                    },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        order.readMore = !order.readMore
                                      }
                                    }
                                  },
                                  [_vm._v("Hidden\n            ")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  })
                ],
                2
              )
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.loading && this.dataList.length === 0
          ? _c("div", { staticStyle: { color: "#999999" } }, [
              _vm._v("No data")
            ])
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _vm.dataList.length > 0
      ? _c(
          "div",
          { staticClass: "page_table" },
          [
            _c("Pagination", {
              attrs: {
                currentPage: _vm.query.current_page,
                total: _vm.total,
                pageSize: _vm.query.page_size
              },
              on: {
                handleSizeChange: _vm.handleSizeChange,
                handleCurrentChange: _vm.handleCurrentChange
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59a1b55e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59a1b55e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/vidirect/refer-orders.vue
// module id = FBVt
// module chunks = 2